function vocabularyIds(vocabulary) {
  return new Set(
    (Array.isArray(vocabulary) ? vocabulary : [])
      .map(concept =>
        typeof concept === 'string' ? concept : concept && concept.id,
      )
      .filter(id => typeof id === 'string' && id.length > 0),
  );
}

/**
 * Validate the concept portion of an enrichment entry without discarding the
 * change. An unknown (including a model-invented id) becomes an explicit queue
 * state; a known id passes through byte-for-byte as the durable join key.
 */
export function classifyCounterpartyConcept(rawConcept, vocabulary) {
  const ids = vocabularyIds(vocabulary);

  if (typeof rawConcept === 'string' && ids.has(rawConcept)) {
    return {
      concept: rawConcept,
      classificationAttempted: true,
      unclassified: false,
    };
  }

  return {
    concept: null,
    classificationAttempted: true,
    unclassified: true,
  };
}

/**
 * Preserve every enrichment entry while enforcing exactly one classification
 * outcome. This helper is used on the response from the combined enrichment
 * call; it never initiates a classification request of its own.
 */
export function validateCounterpartyClassifications(entries, vocabulary) {
  return (Array.isArray(entries) ? entries : []).map(entry => ({
    ...entry,
    ...classifyCounterpartyConcept(entry && entry.concept, vocabulary),
  }));
}
